import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function NotFound() {
  return (
    <main id="contenido" className="not-found">
      <SEO title="Página no encontrada | Fundación Tony" description="La página que buscas no está disponible." path="/404" />
      <span>404</span>
      <h1>Esta página no está disponible</h1>
      <p>Volvamos al inicio para seguir explorando el trabajo de Fundación Tony.</p>
      <Link className="button" to="/"><ArrowLeft /> Regresar al inicio</Link>
    </main>
  );
}
